export enum MODAL_STATE {
  CREATING_REPORT = 'CREATING_REPORT',
  CREATED_REPORT = 'CREATED_REPORT',
}
